// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rq6J","content":"styles_content__L-s4B","row":"styles_row__2b1RA","footer":"styles_footer__1GgRZ","phraseLength":"styles_phraseLength__2GmnH"};